<div class="flex-column height-100 bg-col-w"
     [style]="client.isS || client.isM ? 'border-top-left-radius: 12px; border-top-right-radius: 12px;' : ''">
    <div class="p-a-4-s p-a-4-m p-a-5-l p-a-5-x b-b b-col-5">
        <div class="flex flex-justify-between">
            <div class="flex flex-middle">
                <p class="h3">{{'Filters' | translate}}</p>
                @if (listing.isFiltered()) {
                <div class="m-l-1 b-radius-max bg-col-62 col-1 center"
                     style="width: 20px; height: 20px;">
                    <p class="s2">{{listing.filterSelection.length}}</p>
                </div>
                }
            </div>
            <button type="button"
                    aria-label="Close"
                    (click)="close()">
                <i class="icon-close"
                   aria-hidden="true"></i>
            </button>
        </div>
    </div>

    <!-- content -->
    <div class="overflow-auto custom-scrollbar flex-grow p-l-4-s p-r-4-s p-l-4-m p-r-4-m">
        <!-- listing sort -->
        @if (listing.sort && client.sizeId < 2){
          <listing-sort class="w-12 inline-block"
                        [sort]="listing.sort" />
        }
        @for (filter of listing.getFiltersWithMatches(); track filter) {
        @switch (filter.filterType) {
        @case ('attribute-option') {
        <filter-attribute-option [isDefault]="defaultFilter === filter"
                                 [filter]="filter"></filter-attribute-option>
        }
        }
        }
    </div>

    <!-- footer -->
    <div class="flex w-12 p-l-5 p-r-5 p-t-3 p-b-3 p-l-4-s p-r-4-s p-t-3-s p-t-3-m p-l-4-m p-r-4-m b-t b-col-5">
        <!-- clear -->
        @if (listing.isFiltered()) {
        <button [buttonStyle]="'button-1'"
                class="w-12 m-r-2 m-b-0 "
                (click)="listing.resetFilters()">
            {{'clear filters' | translate }}
        </button>
        }

        <!-- close -->
        <button [buttonStyle]="'button'"
                class="m-b-0 w-12"
                (click)="close()">
            {{ (listing.getTotal() === 1 ? 'view (%)' : 'see (%)') | translate : listing.getTotal() }}
        </button>
    </div>